import {
  QuestionnaireFormProps,
  QuestionnaireQuestions,
} from '../../../models';
import { useEffect, useState } from 'react';
import { Header } from '../../Screen';

import styles from './TextForm.module.scss';

export type TextFormProps<Questionnaire extends QuestionnaireQuestions> = {
  maxLength?: number;
  validate?: (value: string) => boolean;
} & QuestionnaireFormProps<Questionnaire, string>;

export const TextForm = <Questionnaire extends QuestionnaireQuestions>({
  value,
  question,
  onSubmitValue,
  featureName,
  placeholder,
  label,
  maxLength = 400,
  validate,
  setValidForSubmission,
}: TextFormProps<Questionnaire>) => {
  const [text, setText] = useState<string | undefined>(value);

  const handleSubmit = () => {
    if (!text) {
      throw new Error(
        `[${featureName}] Text value is missing for submission for question: ${question}`
      );
    }
    onSubmitValue(text);
  };

  useEffect(() => {
    const isValid = text && (validate ? validate(text) : true);
    setValidForSubmission(Boolean(isValid));
  });

  return (
    <Header onSubmit={handleSubmit}>
      <textarea
        id="qnr-text-area"
        className={`p-input wmn3 ${styles.textbox}`}
        placeholder={placeholder}
        onChange={(e) => setText(e.target.value)}
        value={text}
        maxLength={maxLength}
        data-cy="input-text"
      />
      {!label ? (
        <></>
      ) : (
        <label htmlFor="qnr-text-area" className="p-label">
          {label}
        </label>
      )}
    </Header>
  );
};
